module.exports = __webpack_public_path__ + "img/3bbec5d.jpg";